module.exports = __webpack_public_path__ + "img/shield.040a37c4.svg";